var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "m-slideshow" },
    [
      _c(
        "transition-group",
        { attrs: { tag: "div" } },
        _vm._l(_vm.activeSlides, function(slide) {
          return _c(
            "div",
            {
              key: slide.id,
              staticClass: "m-slideshow__slide",
              style: { transform: "translateX(" + slide.pos + "%" }
            },
            [
              _c("div", { staticClass: "m-slideshow__text" }, [
                _vm._v(" " + _vm._s(slide.text))
              ]),
              _vm._v(" "),
              _c("img", {
                staticClass: "m-slideshow__image lazyload",
                attrs: { "data-src": slide.src, "data-srcset": slide.srcset }
              })
            ]
          )
        })
      ),
      _vm._v(" "),
      _c("div", {
        staticClass: "m-slideshow__left",
        on: {
          click: function($event) {
            _vm.index -= 1
          }
        }
      }),
      _vm._v(" "),
      _c("div", {
        staticClass: "m-slideshow__right",
        on: {
          click: function($event) {
            _vm.index += 1
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }